import { useEffect } from "react"
import ReactDOM from "react-dom"

const useInjectComponent = (Component, selector, dependencies, props = {}) => {
  useEffect(() => {
    const elements = Array.from(
      document.getElementsByClassName(selector)
    ).map((item, index) => {
      if (!item) return null

      const newElement = document.createElement("div")
      newElement.id = `${selector}-injected-component-${index}`
      item.appendChild(newElement)

      const element = typeof Component === "function" ? <Component {...props} /> : Component;
      ReactDOM.render(element, newElement);

      return newElement
    })

    return () => {
      elements.forEach((item) => {
        if (item) {
          ReactDOM.unmountComponentAtNode(item)
          item.remove()
        }
      })
    }
  }, dependencies)
}

export default useInjectComponent



